export const info_colors = (dark) => ({
    main: dark ? '#29b6f6' : '#0288d1',
    light: dark ? '#4fc3f7' : '#03a9f4',
    dark: dark ? '#0288d1' : '#01579b',
    contrastText: dark ? 'rgba(0, 0, 0, 0.87)' : '#fff',
});
